import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHome, FaDashcube } from 'react-icons/fa';
import { MdDashboard, MdFactory, MdFeedback, MdAccountTree } from "react-icons/md";
import { IoIosChatbubbles, IoIosCard } from "react-icons/io";
import logo from '../assets/logos/quick_hire.svg';

const Sidebar = () => {
    return (
        <div className="sidebar">
            <div className="sidebar-logo">
                {/*<img src={logo} alt="Logo" width="75%" style={{ marginTop: '15px' }} className="logo-img"/>*/}
                <img src="https://d2hy6ree306xec.cloudfront.net/employer_files/icons/jobs_new_logo.png" alt="Logo" width="100%" style={{ backgroundColor: 'currentcolor' }} className="logo-img"/>
            </div>
            <Nav className="flex-column mt-3">
                <Nav.Item>
                    <Nav.Link as={Link} to="/"><FaHome className="me-2" /> Home</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/dashboard"><MdDashboard className="me-2" /> Dashboard</Nav.Link>
                </Nav.Item>
                {/*<Nav.Item>*/}
                {/*    <Nav.Link as={Link} to="/about"><IoIosChatbubbles className="me-2" /> Trigger message</Nav.Link>*/}
                {/*</Nav.Item>*/}
                {/*<Nav.Item>*/}
                {/*    <Nav.Link as={Link} to="/create/employer/vacancy"><MdFactory className="me-2" /> Mysqli Vacancy details</Nav.Link>*/}
                {/*</Nav.Item>*/}
                <Nav.Item>
                    <Nav.Link as={Link} to="/create/employer"><MdFactory className="me-2" /> Create employer</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/create/employer/vacancy/new"><MdFactory className="me-2" /> Vacancy entries</Nav.Link>
                </Nav.Item>
                {/*<Nav.Item>*/}
                {/*    <Nav.Link as={Link} to="/about"><MdAccountTree className="me-2" /> Referrel leads</Nav.Link>*/}
                {/*</Nav.Item>*/}
                <Nav.Item>
                    <Nav.Link as={Link} to="/track/employee"><MdAccountTree className="me-2" /> Track employees</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/web/employee/payment/promotion"><IoIosCard className="me-2" /> Employee payment promotion</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/web/employee/payment/employeePayment"><IoIosCard className="me-2" /> Employee payment </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/web/employee/leads"><IoIosCard className="me-2" /> Employee leads</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/web/tiruppur/employee/leads"><IoIosCard className="me-2" /> Tiruppur employee leads</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/file/upload"><IoIosCard className="me-2" /> Payment details</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/create/bill/vacancy"><IoIosCard className="me-2" /> Create Bill</Nav.Link>
                </Nav.Item>
                {/*<Nav.Item>*/}
                {/*    <Nav.Link as={Link} to="/about"><MdFeedback className="me-2" /> Feedback</Nav.Link>*/}
                {/*</Nav.Item>*/}
                {/* Add more links as needed */}
            </Nav>
        </div>
    );
};

export default Sidebar;
